import React, { useState } from 'react';
import { withRouter } from 'react-router-dom';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import { Collapse, CardBody, Card } from 'reactstrap';

import { formatCommentDate } from 'utils/date';
import { ROUTES } from 'constants/Routes';
import 'assets/scss/components/surveyComments.css';

const SurveyAnswerComment = ({ comment: answerComment }) => {
  const [isOpen, setIsOpen] = useState(false);
  const toggle = () => setIsOpen(!isOpen);

  const {
    comment,
    survey_user: surveyUser,
    created_at,
    updated_at,
  } = answerComment;

  const {
    first_name: firstName,
    last_name: lastName,
    age_range: ageRange,
    email,
    gender,
    mobile_number: mobileNumeber,
  } = surveyUser || {};

  return (
    <div className="mt-3 mb-3 survey-comment">
      <FontAwesomeIcon
        opacity={firstName ? 1 : 0.5}
        className="contact-icon cursor-pointer"
        onClick={toggle}
        icon="id-card"
      />
      <div className="w-100">
        <Card className="bg-white styled-box-shadow" onClick={toggle}>
          <CardBody>
            <div className="comment-text">{comment}</div>
            <div className="comment-timestamp">
              {formatCommentDate(created_at || updated_at)}
            </div>
          </CardBody>
        </Card>
        <Collapse className="px-3" isOpen={firstName ? isOpen : false}>
          <Card className="rounded-0 contact-container">
            <span className="chevron-up-icon cursor-pointer" onClick={toggle}>
              <FontAwesomeIcon icon="chevron-circle-up" />
            </span>
            <CardBody>
              <div className="contact-info">
                <span className="name">
                  <FontAwesomeIcon icon="user-alt" />
                  {firstName} {lastName}
                </span>
                <div className="demographics">
                  <span className="mr-1">
                    Age: <b>{ageRange || 'N/A'}</b>
                  </span>
                  <span className="ml-1">
                    Gender: <b>{gender || 'N/A'}</b>
                  </span>
                </div>
              </div>
              <div className="contact-address">
                <div className="email">
                  <FontAwesomeIcon icon="envelope" /> {email || 'N/A'}
                </div>
                <div className="phone">
                  {' '}
                  <FontAwesomeIcon icon="phone" /> {mobileNumeber || 'N/A'}
                </div>
              </div>
            </CardBody>
          </Card>
        </Collapse>
      </div>
    </div>
  );
};

const PublicReportComment = ({ comment }) => {
  return (
    <div className="row comments" key={comment.id}>
      <div className="col-md-12">
        <div className="comment-bubble">
          <p style={{ marginBottom: '5px' }}>{comment.comment}</p>
          <p style={{ textAlign: 'right', margin: 0 }}>
            {formatCommentDate(comment.created_at || comment.updated_at)}
          </p>
        </div>
      </div>
    </div>
  );
};

const SurveyAnswerComments = ({ comments, match }) => {
  const isPublicReport = match.path === ROUTES.PUBLIC_CUSTOM_SURVEY_REPORTS;
  if (comments.length <= 0) return 'No comments';
  if (isPublicReport)
    return comments.map(comment => <PublicReportComment comment={comment} />);
  return comments.map(comment => <SurveyAnswerComment comment={comment} />);
};

export default withRouter(SurveyAnswerComments);



// WEBPACK FOOTER //
// ./src/components/comment/surveyComments.js